/**
 * @generated SignedSource<<1a9c1d64d2791fb564f7ae39941f0bb7>>
 * @relayHash f072fceb2c09bd123661663ff9f1f098
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f072fceb2c09bd123661663ff9f1f098

import { ConcreteRequest } from 'relay-runtime';
export type De_updatePatientCaveEntryInput = {
  message?: string | null;
  patientId: string;
};
export type useDePatientUpdateCaveMutation$variables = {
  input: De_updatePatientCaveEntryInput;
};
export type useDePatientUpdateCaveMutation$data = {
  readonly de_updatePatientCaveEntry: {
    readonly de_Patient: {
      readonly caveEntry: {
        readonly message: string | null;
        readonly updatedAt: string;
        readonly updatedBy: string;
      } | null;
    } | null;
  };
};
export type useDePatientUpdateCaveMutation = {
  response: useDePatientUpdateCaveMutation$data;
  variables: useDePatientUpdateCaveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "CaveEntry",
  "kind": "LinkedField",
  "name": "caveEntry",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedBy",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDePatientUpdateCaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_updatePatientCaveEntryPayload",
        "kind": "LinkedField",
        "name": "de_updatePatientCaveEntry",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "de_Patient",
            "kind": "LinkedField",
            "name": "de_Patient",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDePatientUpdateCaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_updatePatientCaveEntryPayload",
        "kind": "LinkedField",
        "name": "de_updatePatientCaveEntry",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "de_Patient",
            "kind": "LinkedField",
            "name": "de_Patient",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "f072fceb2c09bd123661663ff9f1f098",
    "metadata": {},
    "name": "useDePatientUpdateCaveMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "3f9e8c849a32b0e3763d20382a20e215";

export default node;
